<div class="formRow">
  <mat-form-field class="formField">
    <mat-label>{{ placeholder ?? 'Search ABN' }}</mat-label>
    <input
      matInput
      #search
      [formControl]="formControl"
      (paste)="onPaste($event)"
      (input)="valueChanged()"
      type="text"
      pattern="[0-9]*"
      [maxLength]="11"
      appNumericOnly
    />
    <mat-error *ngIf="formControl.errors?.['required'] && formControl.touched">
      Fund ABN number is required
    </mat-error>
    <mat-error *ngIf="formControl.errors?.['maxlength'] && formControl.touched">
      Fund ABN number must be less than {{formControl.errors?.['maxlength']['requiredLength']}} characters
    </mat-error>
    <mat-error *ngIf="formControl.errors?.['minlength'] && formControl.touched">
      Fund ABN number must be at least {{formControl.errors?.['minlength']['requiredLength']}} characters
    </mat-error>
  </mat-form-field>
  <button
    mat-raised-button
    type="button"
    [disabled]="formControl.invalid"
    (click)="searchABN()"
  >
    Search ABN
  </button>
</div>
